import { render, staticRenderFns } from "./favoritespopover.vue?vue&type=template&id=05406a64&"
import script from "./favoritespopover.vue?vue&type=script&lang=ts&"
export * from "./favoritespopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05406a64')) {
      api.createRecord('05406a64', component.options)
    } else {
      api.reload('05406a64', component.options)
    }
    module.hot.accept("./favoritespopover.vue?vue&type=template&id=05406a64&", function () {
      api.rerender('05406a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/favoritespopover.vue"
export default component.exports